import get from 'lodash.get';

export const FREE_CATEGORY_TITLE = 'Included Workouts';

const mergeSlugs = (stateProps, dispatchProps, ownProps) => {
  const slugKeys = ['categorySlug', 'subcategorySlug'];
  const slugs = slugKeys.reduce(
    (acc, key) => ({
      ...acc,
      [key]: decodeURIComponent(get(ownProps.match, `params[${key}]`, '')),
    }),
    {},
  );

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    ...slugs,
    isFreeCategory: slugs.categorySlug === FREE_CATEGORY_TITLE,
  };
};

export default mergeSlugs;
